document.addEventListener('DOMContentLoaded', function () {
  var heroImg = document.getElementById('productPhotoImg');
  if (!heroImg) return;

  // Force chargement immédiat (si un script a mis lazy)
  heroImg.setAttribute('loading', 'eager');
  heroImg.setAttribute('fetchpriority', 'high');

  // Si lazyload utilise data-src, on le force sur src
  if (heroImg.dataset && heroImg.dataset.src) {
    heroImg.src = heroImg.dataset.src;
  }

  // Si une lib ajoute une classe lazy, on l’enlève
  heroImg.classList.remove('lazyload', 'lazyloading');
});
